import { c as _c } from "react/compiler-runtime";
import { EntityRepository } from '@record-it-npm/synchro-client';
import { useCallback } from 'react';
import { EntityName } from 'record-it-time-common/EntityName';
import { AppEntityManagerEntityTypesByEntityName } from '../../classes/entities/AppEntityManagerEntityTypesByEntityName';
import { useEntityRepository } from './useEntityRepository';

/**
 * provides a callback with which you can modify entities for the given EntityName
 */
export function useModifyEntityCallback(entityName) {
  const $ = _c(2);
  const repository = useEntityRepository(entityName) as EntityRepository<any, any, any>;
  let t0;
  if ($[0] !== repository) {
    t0 = (entity, key, value) => {
      entity[key] = value;
      repository.update(entity);
    };
    $[0] = repository;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export type ModifyEntityCallback<TEntity> = <TKey extends keyof TEntity>(entity: TEntity, key: TKey, value: TEntity[TKey]) => void;